import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { useForm, Controller } from "react-hook-form";
import ApiAmusementService from "../../../core/api/api.amusementService";

const EditAmusementServiceDescription = ({
  showModalUpdateDescription,
  setShowModalUpdateDescription,
  selectedServiceId,
  selectedServiceItemDescription,
  fetchAmusementServiceDescriptions,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue
  } = useForm();

  useEffect(() => {
    setValue("amusementServiceId", selectedServiceId)
    setValue("desc", selectedServiceItemDescription.desc)
    setValue("objectId", +selectedServiceItemDescription.id)
  }, [])

  const handleClose = () => {
    setShowModalUpdateDescription(false);
  };

  const onSubmit = async (data) => {
    try {
      const response = await ApiAmusementService.updateAmusementServiceDescription(data);
      if (response.succeeded == true) {
        handleClose();
        fetchAmusementServiceDescriptions();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showModalUpdateDescription} onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">ویرایش توضیحات فرم رزرو</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col xs="12">
                    <Controller
                      name="desc"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="توضیحات"
                          margin="normal"
                          variant="outlined"
                          value={value || ""}
                          onInput={onChange}
                          multiline
                          minRows={3}
                          maxRows={10}
                          sx={{
                            "& .css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                              padding: "8.5px 14px 8.5px 0px !important",
                            },
                          }}
                        />
                      )}
                    />
                    {errors.desc && <div class="mt-2 pl-4 text-danger">**لطفا توضیح را وارد نمایید</div>}
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default EditAmusementServiceDescription;
